module.exports = __webpack_public_path__ + "img/流体力学4_6.37b08ed7.jpg";